import { formatDuration } from '@local/common-lib';
import type { Theme } from '@mui/material';
import { Box, Card } from '@mui/material';
import type { SxProps } from '@mui/system';
import type { Duration } from 'luxon';
import { DateTime } from 'luxon';
import type { FC } from 'react';

interface Props {
  duration: Duration;
  time: DateTime;
}

const sx: Record<string, SxProps<Theme>> = {
  card: {
    height: '2.8rem',
    minWidth: '4rem',
  },
  duration: {
    height: '1.4rem',
    minWidth: '4rem',
    textAlign: 'center',
  },
  time: {
    backgroundColor: (theme) =>
      theme.palette.mode === 'light' ? theme.palette.grey[700] : '#404040',
    color: (theme) =>
      theme.palette.getContrastText(
        theme.palette.mode === 'light' ? theme.palette.grey[700] : '#404040',
      ),
    height: '1.4rem',
    minWidth: '4rem',
    textAlign: 'center',
  },
};

export const TimeDurationCard: FC<Props> = ({ duration, time }) => {
  return (
    <Card sx={sx.card}>
      <Box sx={sx.time}>{time.toLocaleString(DateTime.TIME_SIMPLE)}</Box>
      <Box sx={sx.duration}>{formatDuration(duration)}</Box>
    </Card>
  );
};
